/** PostHog send-boundary enrichment, isolated to keep its policy directly testable. */

import { resolveAnalyticsContext } from '#~/analytics/utils/context-resolver.js';
import { logger } from '#~/logger/index.js';
// The bypass set and its predicate live in event-names.ts, which has no imports
// of its own — that is what lets the Electron e2e receipt import the SAME rule
// production uses instead of re-deriving it (this module's `#~` deps do not
// resolve under the Playwright loader).
import { POSTHOG_ENVELOPE_BYPASS_EVENTS, shouldEnrichEnvelope } from '#~/posthog/event-names.js';

export { POSTHOG_ENVELOPE_BYPASS_EVENTS, shouldEnrichEnvelope };

/** Minimal local shape because posthog-js types before_send loosely. */
export interface PostHogBeforeSendEvent {
  event?: string;
  properties: Record<string, unknown>;
}

/** Add context idempotently; enrichment failures must never drop the original event. */
export function enrichPostHogEvent(event: PostHogBeforeSendEvent): PostHogBeforeSendEvent {
  if (!event || typeof event.event !== 'string') {
    return event;
  }
  if (!shouldEnrichEnvelope(event.event)) {
    return event;
  }
  try {
    const enriched: Record<string, unknown> = resolveAnalyticsContext(event.properties ?? {});
    return { ...event, properties: enriched };
  } catch (error) {
    logger.error('[PostHog] Failed to enrich analytics context envelope', error);
    return event;
  }
}
